import { postJson,post,get,deleteApi,imagePost } from './axios'
import { postBlob } from './axios2'
const RESOURCE_BASE_PATH = '/deeyeo'

// 明星壁纸-汇总数据
export const deeyeoClickEventSummary = p => postJson(`${RESOURCE_BASE_PATH}/deeyeoClickEventSummary`,p);

// 明星壁纸-汇总每日数据
export const deeyeoClickEventDailySummary = p => postJson(`${RESOURCE_BASE_PATH}/deeyeoClickEventDailySummary`,p);

// 上传图片
export const uploadFileNew = (p,type) => imagePost(`/public/upload/file/`+type, p);

// 保存配置
export const configSave = p => postJson(`${RESOURCE_BASE_PATH}/save`,p);

// 查询配置信息
export const configDetail = p => get(`${RESOURCE_BASE_PATH}/detail`,p);

// 汇总数据导出
export const deeyeoClickEventSummaryExport = p => postBlob(`/jd-hd-web${RESOURCE_BASE_PATH}/statistics/export`,p);